import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { noop } from '../../common';
import { PopperEngine } from '../../common/popper-engine';
import * as classNames from 'classnames';
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leaveTargetDelay = 150;
        _this.state = {
            isVisible: false,
            isInteracting: false
        };
        _this.toggleTooltip = function (isVisible) { return _this.setState({ isVisible: isVisible }); };
        _this.maybeShowTooltip = function () {
            if (!_this.state.isVisible) {
                _this.toggleTooltip(true);
            }
        };
        _this.maybeHideTooltip = function () { return _this.state.isInteracting ? noop() : _this.toggleTooltip(false); };
        _this.delayedMaybeHideTooltip = function () { return setTimeout(_this.maybeHideTooltip, 100); };
        _this.onTooltipBodyEnter = function () { return _this.setState({ isInteracting: true }); };
        _this.onTooltipBodyLeave = function () { return _this.setState({ isInteracting: false }, _this.maybeHideTooltip); };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var align = props.align || '';
        var theme = props.theme || 'dark';
        var tooltipTriggerClassName = namespacedClassnames('tooltip-trigger', props.className);
        var tooltipClassName = namespacedClassnames('tooltip', props.className, theme + "-theme-tooltip");
        var tooltipBody = (React.createElement("div", { className: classNames('tooltip-body', align), onMouseEnter: this.onTooltipBodyEnter, onMouseLeave: this.onTooltipBodyLeave }, props.body));
        var maybeShow = !props.forceHidden && (props.forceVisible || state.isVisible);
        /*
            When the tooltip is rendered relative to body,
            the mouseleave event fires too soon before the mouseenter on tooltip-body does,
            the solution is to delay the event alowing time to move the mouse into the tooltip
        */
        var onMouseLeave = props.relativeToBody ? this.delayedMaybeHideTooltip : this.maybeHideTooltip;
        return (React.createElement("div", { className: tooltipTriggerClassName, onMouseMove: this.maybeShowTooltip, onMouseLeave: onMouseLeave },
            React.createElement(PopperEngine, { body: tooltipBody, show: maybeShow, relativeToBody: !!props.relativeToBody, className: tooltipClassName, direction: props.direction, offset: props.offset, initializeDelayTime: props.initializeDelayTime, popperTargetClassName: props.popperTargetClassName }, props.children)));
    };
    return Tooltip;
}(React.Component));
export { Tooltip };
//# sourceMappingURL=tooltip.js.map